import styled from 'styled-components';

export const StyledAccountConfigurationInfoModalLink = styled.div`
   width: 170px;
`;
StyledAccountConfigurationInfoModalLink.displayName = 'StyledAccountConfigurationInfoModalLink';
